export const MODAL_DIALOG__MOBILE_MENU = 'MODAL_DIALOG__MOBILE_MENU';
